import { useState } from 'react';
import { Globe, Plus, Search } from 'lucide-react';
import WebsiteCard    from './WebsiteCard';
import WebsiteDrawer  from './WebsiteDrawer';
import Pagination     from '../common/Pagination';
import AddClientModal from './AddClientModal';
import './WebsiteSection.css';

function WebsiteSection({ websites, onPageChange, onClientAdded }) {
  const [search,       setSearch]       = useState('');
  const [showModal,    setShowModal]    = useState(false);
  const [drawerWebsite,setDrawerWebsite]= useState(null);

  if (!websites || !websites.success) return null;

  const list = websites.data.websites || [];
  const pagination = websites.data.pagination || {
    total: 0, page: 1, limit: 20, totalPages: 1, hasNextPage: false, hasPrevPage: false,
  };

  const filtered = search.trim()
    ? list.filter(w => w.client_name.toLowerCase().includes(search.toLowerCase().trim()))
    : list;

  function handleClientAdded(data) {
    setShowModal(false);
    if (onClientAdded) onClientAdded(data);
  }

  return (
    <section className="website-section">

      <div className="website-topbar">
        <h2 className="section-title">
          <Globe size={14} className="section-title-icon" />
          Système client Diese
        </h2>

        <div className="website-actions">
          <div className="website-search-wrap">
            <Search size={14} className="website-search-icon" />
            <input
              className="website-search"
              type="text"
              placeholder="Rechercher un client…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <button
            className="website-add-btn"
            onClick={() => setShowModal(true)}
            title="Ajouter un client"
          >
            <Plus size={15} />
            Ajouter
          </button>
        </div>
      </div>

      {filtered.length === 0 && search && (
        <div className="website-empty">
          Aucun client trouvé pour « {search} »
        </div>
      )}

      <div className="website-cards-grid">
        {filtered.map(website => (
          <WebsiteCard
            key={website.client_id}
            website={website}
            onClick={() => setDrawerWebsite(website)}
          />
        ))}
      </div>

      {pagination.totalPages > 1 && !search && (
        <div className="website-pagination-wrap">
          <Pagination pagination={pagination} onPageChange={onPageChange} />
        </div>
      )}

      <WebsiteDrawer
        website={drawerWebsite}
        onClose={() => setDrawerWebsite(null)}
      />

      {showModal && (
        <AddClientModal
          onClose={() => setShowModal(false)}
          onSuccess={handleClientAdded}
        />
      )}

    </section>
  );
}

export default WebsiteSection;
